module.exports = __webpack_public_path__ + "static/media/banner_superOverVR-half.fff01e4a.png";